export default __webpack_public_path__ + "static/media/slideaccesorio1.435425ad.png";